import TagManager from 'react-gtm-module';

TagManager.initialize({
  gtmId: process.env.REACT_APP_GTM_ID as string,
});

export default TagManager;
